import { Spinner as BaseSpinner, SpinnerSize } from '@shipengine/giger';
import { getAsset } from '@utils';

export interface SpinnerProps {
    /** Size of the spinner */
    size?: SpinnerSize;
}

export function Spinner({ size = SpinnerSize.SIZE_SMALL }: SpinnerProps): JSX.Element {
    return <BaseSpinner size={size} image={<img src={getAsset('icons/spinner.svg')} alt="Loading" />} />;
}
